import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

/**
 * Higher-Order Component (HOC) to add a `data-drone-component` attribute to a forwarded ref component.
 * This HOC is specifically designed for components that use `React.forwardRef`.
 *
 * @template Props - The props type of the wrapped component.
 * @template RefType - The type of the forwarded ref.
 * @param WrappedComponent - The component to be wrapped. It must be a `React.ForwardRefExoticComponent`.
 * @returns A new component that wraps the original component and adds a `data-drone-component` attribute
 *          with the component's name or displayName. If neither is available, it defaults to `'UnknownComponent'`.
 */

var WithDroneComponentTrackingForForwarded = function WithDroneComponentTrackingForForwarded(WrappedComponent) {
  var derivedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'UnknownComponent';
  var WithTrackingForForwarded = /*#__PURE__*/React.forwardRef(function (props, ref) {
    var dataDroneComponent = props['data-drone-component'] || derivedComponentName;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      "data-drone-component": dataDroneComponent,
      ref: ref
    }));
  });
  WithTrackingForForwarded.displayName = "WithTracking(".concat(derivedComponentName, ")");
  if (WithTrackingForForwarded.defaultProps) {
    WithTrackingForForwarded.defaultProps = WrappedComponent.defaultProps;
  }
  return WithTrackingForForwarded;
};

/**
 * Higher-Order Component (HOC) to add a `data-drone-component` attribute to a normal functional component.
 * This HOC is designed for components that do not use `React.forwardRef`.
 *
 * @template Props - The props type of the wrapped component.
 * @param WrappedComponent - The component to be wrapped. It must be a functional component (`React.FC`).
 * @returns A new component that wraps the original component and adds a `data-drone-component` attribute
 *          with the component's name or displayName. If neither is available, it defaults to `'UnknownComponent'`.
 */

var WithDroneComponentTrackingForNormal = function WithDroneComponentTrackingForNormal(WrappedComponent) {
  var derivedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'UnknownComponent';
  var WithTrackingForNormal = function WithTrackingForNormal(props) {
    var dataDroneComponent = props['data-drone-component'] || derivedComponentName;
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      "data-drone-component": dataDroneComponent
    }));
  };
  WithTrackingForNormal.displayName = "WithTracking(".concat(derivedComponentName, ")");
  if (WithTrackingForNormal.defaultProps) {
    WithTrackingForNormal.defaultProps = WrappedComponent.defaultProps;
  }
  return WithTrackingForNormal;
};

export { WithDroneComponentTrackingForForwarded, WithDroneComponentTrackingForNormal };
//# sourceMappingURL=WithDroneComponentTracking.js.map
